export var CategorySelect = {
    id: true,
    name: true,
    subtitle: true,
    modeled: true,
    key: true,
    image: {
        select: {
            url: true,
        },
    },
    scope: {
        select: {
            id: true,
            title: true,
            categoryNumber: true,
            subcategoryNumber: true,
        },
    },
    subcategories: {
        select: {
            id: true,
            name: true,
            key: true,
        },
    },
};
//# sourceMappingURL=Category.js.map